import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { ConsultarPreguntasService } from 'src/app/administrador-preguntas/consultar-preguntas.service';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-lista-preguntas',
  templateUrl: './lista-preguntas.component.html',
  styleUrls: ['./lista-preguntas.component.css']
})
export class ListaPreguntasComponent implements OnInit {
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  listaPreguntas;
  displayedColumns: string[] = ["conflictos_asociados","nombre", "ordenFase4"];
  loading=false;

  textoSeleccionar;
  ingles=false;
  constructor(public globals:Globals,private consultarPreguntas:ConsultarPreguntasService,private router:Router) { }

  ngOnInit() {
    this.listaPreguntas=this.globals.listaPreguntas;

    //console.log(this.listaPreguntas)
    this.dataSource = new MatTableDataSource(this.listaPreguntas);
    this.dataSource.paginator = this.paginator;
    if( this.globals.lenguaje == "en" || this.globals.lenguaje == "ingles"){
      this.textoSeleccionar="Select"
      this.ingles=true;
    }else{
      this.textoSeleccionar="Seleccionar"
      this.ingles=false
    }
  }


  seleccionarPregunta(item){
    this.loading=true;
    this.globals.preguntaSeleccionada=item;
 
        this.consultarPreguntas.ConsultarConflictoResumen(this.globals.funcionarioSeleccionado.idtbl_funcionario, 1).subscribe(rt=>{
          //////conole.log(rt)
          this.globals.historialRespuestasSeleccionado=rt;
         
          this.globals.contenedorVarGlobal = "annio";
          this.loading=false;
         
        })
    
  }

}
